import getPlan from '../Customer/get-plan';
import isSuperNice from './is-super-nice';
import isVeryNice from './is-very-nice';

export default function isUnlockTier(user) {
  const userPlan = getPlan(user);

  return isSuperNice(userPlan) || isVeryNice(userPlan);
}
